import { styled } from '@mui/system';

export const Wrapper = styled('main')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;
